import type { GeneratedStairBlock } from "building-types/stairs/stairTypes";
import { aabb3Center } from "geom/aabb3";
import { geomMultiAABB3 } from "geom/geom";

export function generatedStairBlockCentroid(block: GeneratedStairBlock) {
  return aabb3Center(generatedStairBlockAABB3(block));
}

export function generatedStairBlockAABB3(block: GeneratedStairBlock) {
  return geomMultiAABB3(block.geom.geom);
}
